import { useAlert } from 'components/alert'
import { useErrorHandler } from 'components/error'
import { confirm } from 'components/modals/confirm'
import { useUpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutation } from 'graphql/hooks.generated'
import { useCallback } from 'react'

import { MSG_ATIVACAO_GRUPO_AC_MODAL, MSG_INATIVACAO_GRUPO_AC_MODAL } from '../utils-atividadeColetivaGrupos'

interface UseAtividadeColetivaGruposStatusAtivoUpdateOptions {
  onSuccess?: () => void
}

export const useAtividadeColetivaGruposStatusAtivoUpdate = (
  options: UseAtividadeColetivaGruposStatusAtivoUpdateOptions
) => {
  const { onSuccess } = options
  const handleRejection = useErrorHandler()
  const alert = useAlert()
  const [
    updateStatusAtivoGrupoParticipanteAtividadeColetiva,
  ] = useUpdateStatusAtivoGrupoParticipanteAtividadeColetivaMutation()

  const updateStatusAtivo = useCallback(
    (grupoParticipanteAtividadeColetivaId: ID, isGrupoAtivo: boolean) => {
      const updatedStatusAtivo = !isGrupoAtivo
      const alertMessage = isGrupoAtivo ? 'Grupo inativado com sucesso.' : 'Grupo ativado com sucesso.'

      confirm({
        title: isGrupoAtivo ? 'Deseja inativar o grupo?' : 'Deseja ativar o grupo?',
        confirmLabel: isGrupoAtivo ? 'Inativar' : 'Ativar',
        body: isGrupoAtivo ? MSG_INATIVACAO_GRUPO_AC_MODAL : MSG_ATIVACAO_GRUPO_AC_MODAL,
        onConfirm: () =>
          updateStatusAtivoGrupoParticipanteAtividadeColetiva({
            variables: {
              grupoParticipanteAtividadeColetivaId,
              ativo: updatedStatusAtivo,
            },
          })
            .then(() => {
              onSuccess?.()
              alert('success', alertMessage)
            })
            .catch(handleRejection),
      })()
    },
    [updateStatusAtivoGrupoParticipanteAtividadeColetiva, onSuccess, alert, handleRejection]
  )

  return { updateStatusAtivo }
}
